export default __webpack_public_path__ + "static/media/iconLogo.23433da1.svg";